// 解决 util._extend 弃用警告的 polyfill
// 该警告通常来自于某些依赖包使用了已弃用的 Node.js API

// 尝试在全局作用域中查找 util 对象或通过不同方式获取它
(function () {
	try {
		let util;

		// 1. 尝试通过 require 获取 util 模块（Node.js 环境）
		if (typeof require === "function") {
			try {
				util = require("util");
			} catch (e) {
				// 如果 require 失败，继续尝试其他方式
			}
		}

		// 2. 尝试在 window 对象上查找 util（浏览器环境）
		if (!util && typeof window !== "undefined") {
			util = window.util;
		}

		// 3. 尝试在 global 对象上查找 util（Node.js 或某些构建工具环境）
		if (!util && typeof global !== "undefined") {
			util = global.util;
		}

		// 如果找到了 util 对象并且没有 _extend 方法，但有 Object.assign
		if (util && !util._extend && typeof Object.assign === "function") {
			// 用 Object.assign 替换 util._extend
			util._extend = function (target, source) {
				return Object.assign(target, source);
			};
		}
	} catch (e) {}
})();
